// Real backend origin, set at build time from REACT_APP_BACKEND_URL so
// staging/prod can be switched without editing source. Falls back to the
// production host so a missing env var never breaks the build.
const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_URL
  ? process.env.REACT_APP_BACKEND_URL.replace(/\/+$/, '')
  : 'https://pharma-outlet.com';

// In local dev the app runs on localhost but the backend sends no CORS headers,
// so direct cross-origin API calls are blocked by the browser (empty data,
// e.g. no hero category bubbles). Use a relative "/api" base in dev so requests
// go through the CRA dev proxy (src/setupProxy.js), which forwards them to the
// backend server-side — no CORS. Production builds hit the backend directly
// (same-origin once deployed), exactly as before.
const isDev = process.env.NODE_ENV === 'development';

const config = {
    basename: '',
    baseURL: isDev ? '/api' : `${BACKEND_ORIGIN}/api`,
    rtlLayout: false,
  };

  // Images can be loaded cross-origin by <img> without triggering CORS, so
  // always point them at the real backend origin (even in dev).
  config.imageBaseURL = BACKEND_ORIGIN;
  config.uploadsPath = '/uploads';

  export default config;
